import React, { useEffect, useMemo, useState } from "react";
import { Typography, Tooltip, Box, Icon } from "@mui/material";
import dayjs from "dayjs";
import AccessAlarmIcon from "@mui/icons-material/AccessAlarm";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";

const LastDateToApply = ({
  lastDate,
  highlightColor = "primary.dark",
  customfontsize,
}) => {
  const getRemainingDays = (lastDate) => {
    const today = dayjs();
    const deadline = dayjs(lastDate);
    return deadline.diff(today, "day");
  };

  const remainingDays = getRemainingDays(lastDate);

  const applyDateStyle = useMemo(() => {
    if (remainingDays < 0) return { color: "error.dark", fontWeight: "bold" };
    if (remainingDays <= 7)
      return { color: "warning.dark", fontWeight: "bold" };
    return { color: highlightColor };
  }, [remainingDays, highlightColor]);

  const getStatusIcon = useMemo(() => {
    const iconStyle = {
      fontSize: `${customfontsize}px`,
      padding: "0px",
      margin: "0px",
    }; // Define the icon font size
    if (remainingDays < 0)
      return <ErrorIcon sx={{ color: "error.dark" }} style={iconStyle} />;
    if (remainingDays <= 7)
      return (
        <AccessAlarmIcon sx={{ color: "warning.dark" }} style={iconStyle} />
      );
    return <CheckCircleIcon sx={{ color: highlightColor }} style={iconStyle} />;
  }, [remainingDays, customfontsize, highlightColor]);

  const tooltipText = useMemo(() => {
    if (remainingDays < 0) return "The deadline has passed.";
    if (remainingDays <= 7) return "Hurry! The deadline is approaching soon.";
    return "There is enough time to apply.";
  }, [remainingDays]);

  const [colorIndex, setColorIndex] = useState(0);
  const colors = ["#FF5733", "#33FF57", "#3357FF", "#FF33A1"]; // Vibrant colors

  useEffect(() => {
    const interval = setInterval(() => {
      setColorIndex((prevIndex) => (prevIndex + 1) % colors.length); // Cycle through the colors
    }, 2000); // Change color every 2 seconds

    return () => clearInterval(interval); // Clean up the interval
  }, []);

  return (
    <Tooltip
      title={tooltipText}
      arrow
      style={{
        padding: 0,
        margin: 0,
        position: "relative", // Set the background color based on state

        width: "100%",
      }}
      placement="top-start"
    >
      <Box
        display="flex"
        alignItems="center"
        justifyContent={"start"}
        style={{
          position: "relative", // Set the background color based on state
          mt: 2,
          width: "100%",
          padding: "5px",
          textAlign: "start",
        }}
        sx={{
          borderTop: (theme) => `1px solid ${theme.palette.grey[200]}`,
          boxShadow: (theme) => `0px 2px 5px ${theme.palette.grey[200]}`,
        }}
      >
        {getStatusIcon}
        <Typography
          variant="h6"
          sx={{ ml: 1, ...applyDateStyle }}
          style={{
            display: "flex", // Use flexbox layout
            alignItems: "center", // Vertically center the text
            justifyContent: "flex-start", // Align text to the left horizontally
            lineHeight: `${1.1 * customfontsize}px`,
            overflow: "hidden",
            textAlign: "start",
            height: `${2.5 * customfontsize}px`, // Set the height for vertical centering
            fontSize: `${customfontsize}px`,
            paddingRight: "20px",
          }}
        >
          {remainingDays < 0
            ? "Deadline Passed"
            : `Last Date to Apply: ${dayjs(lastDate).format("MMM DD, YYYY")}`}
        </Typography>

        <Icon
          style={{
            position: "absolute",

            right: "10px",
            top: "50%",
            transform: "translateY(-50%) ",
            color: "transparent",
            transformOrigin: "top right",
            color: colors[colorIndex],
            transition: "background-color 1s ease", // Smooth transition for color change
            padding: "0px",
            margin: "0px",
            fontSize: `${customfontsize}px`,

            textAlign: "center",
            zIndex: 1000,
          }}
        >
          schedule
        </Icon>
      </Box>
    </Tooltip>
  );
};

export default LastDateToApply;
